module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-feb676c4.png";